import { type ColumnDef } from '@tanstack/react-table'
import { type DocumentsViewerContentFilter } from 'routes/documents/-searchParams'
import { InputType } from 'types'

export const PAGE_SIZE = 50

export const CONTENT_TABS: {
  label: string
  value: DocumentsViewerContentFilter
}[] = [
  { label: 'Documents', value: 'documents' },
  { label: 'Sensors', value: 'sensors' },
]

export const PLACEHOLDER_MAP: Record<DocumentsViewerContentFilter, string> = {
  documents: 'Search documents...',
  sensors: 'Search sensors...',
}

export const DOCUMENT_FILTER_COLUMNS: ColumnDef<Record<string, unknown>>[] = [
  {
    id: 'docType',
    header: 'Type',
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
  {
    id: 'vendor',
    header: 'Vendor',
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
  {
    id: 'system',
    header: 'System',
    enableColumnFilter: true,
    meta: { inputType: InputType.Text },
  },
]
